export default "__VITE_ASSET__Ak2VcJbc__"